import { Address } from "./address.model";
import { FirestoreDataConverter } from "@angular/fire/firestore";
import { ShipmentStateEnum } from "../enums/shipment-state.enum";

export class WebShipmentModel {
  public id: string;
  public organizationId: string;
  public trackingUrl: string;
  public address: Address;
  public quantity = 0;
  public product = '';
  public order = '';
  public state: ShipmentStateEnum;

  constructor(data?: Partial<WebShipmentModel>) {
    this.id = data?.id ?? '';
    this.organizationId = data?.organizationId ?? '';
    this.trackingUrl = data?.trackingUrl ?? '';
    this.address = data?.address ? new Address(data.address) : new Address();
    this.quantity = data?.quantity ?? 0;
    this.product = data?.product ?? '';
    this.order = data?.order ?? '';
    this.state = data?.state ?? ShipmentStateEnum.UNKNOWN;
  }

  /**
   * Converter used to convert a web shipment from firebase
   */
  static converter: FirestoreDataConverter<WebShipmentModel> = {
    toFirestore: shipment => ({
      id: shipment.id,
      organizationId: shipment.organizationId,
      trackingUrl: shipment.trackingUrl,
      address: shipment.address,
      quantity: shipment.quantity,
      product: shipment.product,
      order: shipment.order,
      state: shipment.state,
    }),
    fromFirestore: (snapshot, options) => new WebShipmentModel({ ...snapshot.data(options), id: snapshot.id })
  };
}
